import React from 'react';
import {Formik, Field, FormikProps} from 'formik';
import classNames from 'classnames';

import {Form, Button, ReCaptcha} from '@components';
import validations from '@validations';
import utils from '@utils';
import mappings from '@mappings';
import resources from '@resources';
import {Props} from './types';

import './index.scss';

const SignUp: React.FC<Props> = props => {
  const initialValues = props.initialValues;
  return (
    <div className={classNames('w__signup-forms', {modal: props.modal})}>
      <Formik
        validate={
          props.modal
            ? validations.signUp.registerInformation
            : validations.signUp.main
        }
        initialValues={initialValues}
        onSubmit={props.handleSubmit}
        enableReinitialize
      >
        {(formProps: FormikProps<any>) => {
          return (
            <>
              <div className="w__sign-up-field">
                <div className="w__input">
                  <Form.Label text="姓" required />
                  <Field
                    component={Form.Input}
                    placeholder="姓"
                    name="lastName"
                    disabled={formProps.isSubmitting}
                  />
                </div>
                <div className="w__input">
                  <Form.Label text="名" required />
                  <Field
                    component={Form.Input}
                    placeholder="名"
                    name="firstName"
                    disabled={formProps.isSubmitting}
                  />
                </div>
              </div>
              <div className="w__sign-up-field">
                <div className="w__input">
                  <Form.Label text="セイ" required />
                  <Field
                    component={Form.Input}
                    placeholder="セイ"
                    name="lastKana"
                    disabled={formProps.isSubmitting}
                  />
                </div>
                <div className="w__input">
                  <Form.Label text="メイ" required />
                  <Field
                    component={Form.Input}
                    placeholder="メイ"
                    name="firstKana"
                    disabled={formProps.isSubmitting}
                  />
                </div>
              </div>
              <div className="w__sign-up-input">
                <Form.Label text="性別" />
                <Field
                  component={Form.Dropdown}
                  placeholder="性別 "
                  name="gender"
                  disabled={formProps.isSubmitting}
                  options={utils.mappings.createSelections(mappings.gender)}
                />
              </div>
              <div className="w__sign-up-input">
                <Form.Label text="生年月日" />
                <div className="birthdate">
                  <Field
                    component={Form.Dropdown}
                    placeholder="年"
                    name="birthyear"
                    disabled={formProps.isSubmitting}
                    options={resources.users.getBirthSelections('years')}
                    size="sm"
                    hideErrorMessage
                  />
                  <Field
                    component={Form.Dropdown}
                    placeholder="月"
                    name="birthmonth"
                    disabled={formProps.isSubmitting}
                    options={resources.users.getBirthSelections('months')}
                    size="sm"
                    hideErrorMessage
                  />
                  <Field
                    component={Form.Dropdown}
                    placeholder="日"
                    name="birthday"
                    disabled={formProps.isSubmitting}
                    options={resources.users.getBirthSelections('days', {
                      currentYear: formProps.values.birthyear,
                      currentMonth: formProps.values.birthmonth,
                    })}
                    size="sm"
                    hideErrorMessage
                  />
                </div>

                <Form.Error>
                  {resources.users.getBirthError(
                    formProps.errors,
                    formProps.touched,
                    {
                      year: 'birthyear',
                      month: 'birthmonth',
                      day: 'birthday',
                    }
                  )}
                </Form.Error>
              </div>

              <div className="w__sign-up-input">
                <Form.Label text="メールアドレス" required />
                <Field
                  component={Form.Input}
                  placeholder="メールアドレス"
                  name="email"
                  disabled={formProps.isSubmitting || props.modal}
                />
              </div>
              <div className="w__sign-up-input">
                <Form.Label text="携帯番号" />
                <Field
                  component={Form.Input}
                  placeholder="携帯番号"
                  name="phoneNumber"
                  disabled={formProps.isSubmitting}
                  maxLength={13}
                />
              </div>
              <div className="w__sign-up-input">
                <Form.Label text="地域" required />
                <Field
                  component={Form.Dropdown}
                  placeholder="地域"
                  name="prefecture"
                  disabled={formProps.isSubmitting}
                  options={utils.mappings.createSelections(
                    mappings.prefectures
                  )}
                />
              </div>
              <div className="w__sign-up-input">
                <Form.Label text="所属組織" />
                <Field
                  component={Form.Input}
                  placeholder="所属組織"
                  name="organization"
                  disabled={formProps.isSubmitting}
                />
              </div>
              <div className="w__sign-up-input">
                <Form.Label text="役職" />
                <Field
                  component={Form.Input}
                  placeholder="役職"
                  name="position"
                  disabled={formProps.isSubmitting}
                />
              </div>
              {props.modal ? null : (
                <>
                  <div className="w__sign-up-input">
                    <Form.Label text="パスワード" required />
                    <Field
                      component={Form.Input}
                      placeholder="パスワード"
                      type="password"
                      maxLength={20}
                      disabled={formProps.isSubmitting}
                      name="password"
                    />
                  </div>
                  <div className="w__sign-up-input">
                    <Form.Label text="確認用パスワード" required />
                    <Field
                      component={Form.Input}
                      placeholder="確認用パスワード"
                      maxLength={20}
                      type="password"
                      disabled={formProps.isSubmitting}
                      name="confirmPassword"
                    />
                  </div>
                </>
              )}

              {props.setReCaptchaToken ? (
                <div className="w__recaptcha">
                  <ReCaptcha
                    onChange={(value: any) => {
                      utils.reCaptcha.submit(value, props.setReCaptchaToken);
                    }}
                  />
                  <Form.Error>
                    {utils.reCaptcha.error(
                      formProps.submitCount,
                      props.reCaptchaToken
                    )}
                  </Form.Error>
                </div>
              ) : null}

              <div className="w__confirm-button">
                <Button.Normal
                  text={props.submitText}
                  color="yellow"
                  rounded
                  className="b__sign-up-button"
                  disabled={formProps.isSubmitting}
                  loading={formProps.isSubmitting}
                  onClick={() => {
                    formProps.handleSubmit();
                  }}
                />
              </div>
            </>
          );
        }}
      </Formik>
    </div>
  );
};

export default SignUp;
